export const LOCALE_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

export const toLocalDateString = (dateString: string) => new Date(dateString).toLocaleString('nl', LOCALE_DATE_OPTIONS);
